export default __webpack_public_path__ + "fc705122bacd708c5fd6f4087f997ce5.svg";